import styled from "styled-components";
import { Card } from "@mui/material";
import { IThemeProps } from 'component/theme';

export const max2lines = (theme: any) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  line-height:  ${theme.uptimeLineHeights.desktop.lh4}px;
  padding-top: ${theme.uptimeSpace[3]}px;
`;

export const maxlines = (theme: any, line: number) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
  line-height:  ${theme.uptimeLineHeights.desktop.lh4}px;
`;

export const StyledDeviceSelection: any = styled(Card)`
  ${({theme, isMobileView}: IThemeProps & {isMobileView: boolean }) => `
    padding: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]};
    width: 100%;
    height: 100%;

    .uptime-typography {
      font-family:${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
      color: ${theme.uptimeColors.grayScales.black};
    }

    .MuiFormControlLabel-label {
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      font-weight: 500;
      color: ${theme.uptimeColors.mainTheme.primary};
    }

    .comparison-header {
      flex: 1;
      font-size: ${theme.uptimeFontSizes.desktop.fz9}px !important;
      padding: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]};
      text-align: center;
      position: relative;
    }

    .stepper-label {
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      text-align: center;
      margin: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]} !important;
      padding: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[15]}px;
    }

    .grid-comparison {
      flex-wrap: nowrap;
      padding: ${theme.uptimeSpace[5]}px;
      gap: ${isMobileView ? theme.uptimeSpace[0] : theme.uptimeSpace[10]}px;
    }

    .comparison-card-container {
      padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[20]}px;
      margin: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[6]}px;
      width: ${isMobileView ? "30%" : "90%"};
      position: relative;
      flex: 1;
      border: 1px solid ${theme.uptimeColors.grayScales.lightBorder};
      border-radius: 8px;
      box-shadow: ${theme.uptimeColors.grayScales.boxShadow} -4px 4px;
    
      &.selected {
        border: 1px solid ${theme.uptimeColors.mainTheme.primary};
        background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.grayScale.cardSelected};
      }

      &.MuiCard-root {
        overflow: visible;
      }

      img.device-image {
        width: 150px;
        height: 150px;
        object-fit: contain;
      }

      .manufacturer {
        font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
        text-transform: uppercase;
      }

      .title {
        ${(maxlines(theme, 2))};
        min-height: 44px;
        font-weight: 600;
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        max-width: ${isMobileView ? "unset" : '200px'};
      }

      .close-button {
        position: absolute;
        z-index: 10;
        top: -${theme.uptimeSpace[6]}px;
        right: -${theme.uptimeSpace[6]}px;
        width: 24px;
        height: 24px;
        overflow: hidden;
        display: flex;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        background-color: ${theme.uptimeColors.grayScales.white};
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px -2px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px, rgba(0, 0, 0, 0.09) 0px 5px 12px 4px;
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        &:hover {
          background:${theme.uptimeColors.grayScales.white};
          transition: transform 0.4s ease 0s;
          transform: scale(1.3);
        }
      }

      img.placeholder {
        padding: ${theme.uptimeSpace[10]}px;
        width: 80%;
      }

      .specification-container {
        flex: 1;
        line-height: normal;

        * {
          margin: 0;
          padding: 0;
          font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        }

        .specification {
          font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
          font-weight: 500;
        }

        h3 {
          font-weight: bold;
          margin-bottom: ${theme.uptimeSpace[8]}px;
        }

        .specification-content {
          .spec-details {
            display: flex;
            align-items: center;
            border-radius: 6px;
            overflow: hidden;
            border: 1px solid ${theme.uptimeColors.grayScales.white};
            min-height: 35px;

            .spec-value {
              display: flex;
              align-items: center;
              padding: 0 ${theme.uptimeSpace[5]}px;
              font-weight: 500;
              ${maxlines(theme, 1)};
            }

            .spec-icon {
              width: 30px;
              height: 30px;
              min-width: 30px;
              padding:  ${theme.uptimeSpace[2]}px;
              background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.grayScale.specBackground};
            }
          }

          &>div:nth-child(odd) {
            background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.grayScale.specLine1};
          }

          &>div:nth-child(even) {
            background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.grayScale.specLine2};
          }
        }
      }

      .actions {
        margin-top: ${theme.uptimeSpace[16]}px;
        position: relative;

        .expand-collapse {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 50%;
          right: ${theme.uptimeSpace[0]};
          cursor: pointer;
        }
      }
    }

    .slider-container {
      margin-top: ${theme.uptimeSpace[16]}px;
      max-width: 100%;

      .device-slider-header {
        margin-bottom: ${theme.uptimeSpace[8]}px;
        text-align: center;
        strong {
          font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
          font-weight: 500;
        };
        small {
          font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        }
      }

      .device-slider {
        width: 100%;
        padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[10]}px;
    
        .slick-slide {
          padding: ${theme.uptimeSpace[4]}px;
          box-sizing: border-box;
          height: inherit !important;
          flex: auto;

          &>div {
            height: 100%;
          }
        }

        .slick-track {
          display: flex !important;
        }

        .slick-arrow {
          color: ${theme.uptimeColors.generalColors.icon.enabled} !important;
          width: 40px;
          height: 40px;
          box-shadow: rgb(0 0 0 / 7%) 0px 1px 0px -5px, rgb(0 0 0 / 5%) 0px 3px 5px 0px, rgb(0 0 0 / 4%) 0px 3px 7px 3px;
          svg {
            font-size: 40px;
          }
          &.slick-next {
            right: 5px;
          }
          &.slick-prev {
            left: 5px;
          }
          &.slick-disabled {
            display: none !important;
          }
        }

        .slider-card-container {
          position: relative;
          height: 100%;
          background: ${theme.uptimeColors.grayScales.white};
          padding: ${theme.uptimeSpace[6]}px;
          box-sizing: border-box;
          border: 1px solid ${theme.uptimeColors.grayScales.lightBorder};
          border-radius: 8px;
          box-shadow: ${theme.uptimeColors.grayScales.boxShadow} -4px 4px;

          .align-right-content {
            text-align: right;
          }

          &.selected {
            background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.grayScale.cardSelected};
          }

          .grid-column-source-box { 
            margin-top: ${theme.uptimeSpace[8]}px;
          }

          img.device-image {
            width: 100px;
            height: 100px;
            object-fit: contain;
          }

          .spec-details {
            display: flex;

            .spec-value {
              align-items: center;
              padding-left: ${theme.uptimeSpace[5]}px;
              font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
              flex: 1;
              ${maxlines(theme, 1)};
              &.spec-value-keyboard {
                line-height: unset;
                .MuiAutocomplete-root .MuiInputBase-root {
                  height: auto !important;
                }
              }
            }

            .txt-keyboard {
              padding: 7px 0;
              margin: 0;
              height: 100%;
              width: 100%;
              display: flex;
              align-items: center;
              flex: 1;              
              ${maxlines(theme, 1)};
            }

            .MuiInputBase-input {
              height: 32px;
              padding: 0 12px !important;
            }

            .spec-icon {
              width: 30px;
              height: 30px;
              padding: ${theme.uptimeSpace[2]}px;
            }
          }

          .title {
            ${(maxlines(theme, 2))};
            min-height: 50px;
            font-weight: 700;
            padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]};
            max-width: ${isMobileView ? "unset" : '200px'};
          }

          .manufacturer {
            text-transform: uppercase;
            font-weight: bold;
          }

          .description {
            font-weight: 600;
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
          }

          .model {
            margin-top: ${theme.uptimeSpace[8]}px;
          }

          .compare-check {
            margin: ${theme.uptimeSpace[0]};
            padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]};
            background-color: ${theme.uptimeColors.dynamicForm.deviceSelection.eyeBrow.background};
            border-radius: 6px;
            color: ${theme.uptimeColors.mainTheme.primary};

            svg.MuiSvgIcon-root {
              font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
            }

            .MuiFormControlLabel-label {
              font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
              font-weight: bold;
              font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
            }

            .MuiCheckbox-root {
              padding: ${theme.uptimeSpace[1]}px ${theme.uptimeSpace[2]}px;
            }
          }

          .title-recommended {
            padding: ${theme.uptimeSpace[1]}px ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]};
            font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
          }
        }
      }
    }
  
  `}
`